import { tmxApiCall } from './index'

// Utilities
import Logger from '../utility/loggerUtil'

export default {
  async getPaymentState (cognitoId) {
    Logger.info('Started get payment state query')
    return tmxApiCall('get', '/usercache', {
      params: {
        customerId: cognitoId
      }
    })
  },

  async postPaymentState (cognitoId, state) {
    Logger.info('Started post payment state request')
    return tmxApiCall('post', '/usercache', {
      customerId: cognitoId,
      value: state
    })
  }
}
